a<template>
    <div class="w">
      <div class="datails_nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            <i class="el-icon-s-home" />首页
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.query.type == 4" :to="{ path: '/Assume' }">揭榜挂帅</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ path: '/AboutPublicity' }">公示鉴证</el-breadcrumb-item>
  
          <el-breadcrumb-item v-if="$route.query.type == 4">通知详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 标题 -->
     <div class="zw" >
   <h1 style="font-size: 2rem;">{{item.PublicityAssuranceName}}</h1>
<div class="box1">根据《中华人民共和国促进科技成果转化法（2015修订）》、国务院《实施《中华人民共和国促进科技成果转化法》若干规定》（国发（2016）16号）、国务院办公厅《促进科技成果转移转化行动方案》（国办发（2016）28号）和教育部、科技部《关于加强高等学校科技成果转移转化工作的若干意见》（科技（2016）3号）等法律法规，现对我拟转让的成果相关情况公式如下：</div>
<div style="text-align: left;">一、拟转让成果相关
<div class="box2" >
  <table>
      <thead>
      <tr>
         <th>序号</th>
         <th>专利名称</th>
         <th>专利类型</th>
         <th>专利号</th>
         <th>专利权人</th>
         <th>发明人</th>
      </tr>
      </thead>
      <tbody>
  
      <tr>
        <td>1</td>
         <td>{{item.PatentName}}</td>
         <td>{{item.PatentType}}</td>
         <td>{{item.PatentNumber}}</td>
         <td>{{item.Patentee}}</td>
         <td>{{item.Inventor}}</td>
      </tr>
      <!-- <tr>
        <td></td>
         <td></td>
         <td></td>
         <td></td>
         <td></td>
         <td></td>
      </tr> -->
   </tbody>
   </table>
</div>
<div class="box3">
  二、拟受让方
  <div style="margin-top: 1rem;">{{item.Transferee}}</div>
</div>
<div class="box4">
  三、定价方式
  <div style="margin-top: 1rem;">{{item.PricingMethod}}</div>
</div>
<div class="box4">
  四、拟交易价格
  <div style="margin-top: 1rem;">{{ item.PricingAmount }}</div>
</div>
<div class="box4">
  五、价格形成过程
  <div style="margin-top: 1rem;"></div>
  <div>{{item.PriceFormationProcess}}特此公示，公示期为{{item.StartDate}}至{{item.EndDate}}如有异议，可在公示期内以书面形式提出。意义应当签署真实姓名，否则不予受理。</div>
</div>
<div class="box4"  >
 
<span>附件名称：</span>
<div style="display: flex;" v-if="item.FileUrls.length >= 1">
  <ul>
  <li>
  <div
                      class="card_pop"
                    v-for="(v,i) in item.FileName.slice(0, -1).split('|')"
                      :key="i"
          
                    >{{ v }}
                   
<!--                
<el-button size="mini" v-for="(v,i) in item.FileUrls.slice(0, -1).split('|')"
                      :key="i">
    
                       <a :href="v" download="v" target="_blank" >下载</a>
                    </el-button>  -->
                  </div>
  </li>
  </ul>
  <ul>
    <li>
  <div v-for="(v,i) in item.FileUrls.slice(0, -1).split('|')"
                      :key="i" class="xzBtn">
                      <a :href="v" download="v" target="_blank" >下载</a>
</div>
    </li>
  </ul>
</div>
                   
</div>
<div class="box4">
  联系电话：{{ item.ContactNumber }}
  <span></span>
</div>
<div class="box4">
  联系人：{{ item.ContactPerson }}
  <span></span>
</div>
<div class="box5">
  <!-- 河南工程学院 -->
</div>
</div>

     </div>
      <div class="tent" v-html="list.Details"></div>
    </div>
  </template>
  <script>
  import { getAction, postAction } from '@/api/api'
  import qs from 'qs'
  import { NewsList,PublicityAssuranceHander } from '@/api/url'
  import $ from '../../../public/jquery-2.1.1.js'
  export default {
    data() {
      return {
        item:{},
        itemList:[],
          //人才库参数
      taleget: {
        action:'Get_PublicityAssuranceInfo',
        id:this.$route.query.id,
      },
        list: {},
        Newid: '',
      }
    },
    created() {
      this.talentList()
      //首页产经资讯和 政策法规 判断 勿动
      this.Newid = this.$route.query.id
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        this.LoadOthers(this.$route.query.type)
      } else {
        this.NewsIfo()
      }
    },
    mounted() {
      this.ToNewsInfo()
    },

    methods: {
      talentList() {
      getAction(PublicityAssuranceHander, this.taleget).then((res) => {

        this.item = res;
      })
    },
  
       ToNewsInfo() {
        //判断是否是PC设备，true是，false不是
           //判断是否是PC设备，true是，false不是
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
        let flag = true
        for (let j = 0; j < Agents.length; j++) {
          if (userAgentInfo.indexOf(Agents[j])>0) {
            flag = false
            break
          }
        }
        if (window.screen.width >= 768) {
          flag = true
        }
        if (flag) {
          this.$router.push({
            path: '/publicity',
            query: { type: this.$route.query.type, id: this.Newid },
          })
        } else {
         window.location.href=this.Urls+'/Mobile/index.html#/AboutNotice?data=' + this.Newid + '&type='+ this.$route.query.type
        }
      },
      // LoadOthers(n) {
      //   let vm = this;
      //   let data = {
      //     action: "Get_InformationTzggDetails",
      //     Type:n,
      //     ID: vm.Newid
      //   };
  
      //   postAction(NewsList, this.$qs.stringify(data)).then((res) => {
      //     console.log(res)
      //     vm.list = {
      //          Titile: res.Titile,
      //          SourceWebsite: res.SourceWebsite,
      //          CreateTime: res.CreateTime,
      //          ReadingVolume: 0,
      //          Details: res.Details,
      //       }
      //   });
        // let url1 ="";
        // if(n==1)
        // {
        //    url1 =   'http://122.112.231.161:13500/r4QwXEGi/api/industry/category/detail?id=' //"http://122.112.231.161:1333/r4QwXEGi/api/policy/category/detail?id=";
        // }
        // else
        // {
        //   url1 =  'http://122.112.231.161:13500/r4QwXEGi/api/policy/category/detail?id=';
        // }
        
        // let vm = this
        // $.ajax({
        //   type: 'get',
        //   url:
        //   url1 + vm.Newid,
        //   dataType: 'json',
        //   async: false,
        //   success: function (data) {
        //     vm.list = {
        //       Titile: data.data.name,
        //       Spare2: data.data.properties.来源网站,
        //       CreateTime: data.data.properties.发布时间,
        //       ReadingVolume: 0,
        //       Details: data.data.properties.内容,
        //     }
        //     //// console.log(vm.list);
        //   },
        // })
      // },
      // NewsIfo() {
      //   let data = {
      //     action: 'Get_InformationInfo',
      //     ID: this.Newid,
      //   }
      //   postAction(NewsList, this.$qs.stringify(data)).then((res) => {
      //     //// console.log("Get_InformationInfo", res);
      //     this.list = res
      //   })
      // },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  body {
    margin: 0rem;
    font-family: Microsoft YaHei;
    left: 0rem;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    box-sizing: border-box;
    overflow: hidden;
  }
  .w {
    width: 80rem;
    margin: 3rem auto 5rem;
    overflow: hidden;
  }
  
  #header {
    height: 7.4375rem;
    border-bottom: 0.0625rem solid #ffffffa9;
    background-color: #222222;
    width: 100%;
  }
  .datails_nav {
    text-align: left;
    height: 5.125rem;
    line-height: 5.125rem;
    font-size: 0.875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  
  .datails_nav .layui-breadcrumb a {
    color: #222222 !important;
  }
  .datails_nav .layui-breadcrumb img {
    width: 0.875rem;
    height: 0.875rem;
    margin-right: 0.625rem;
  }
  /* 标题 */
  .toptitlet {
    text-align: center;
  }
  .lang {
    margin: 0 0.625rem;
    color: #999;
  }
  .titletext {
    font-size: 2.2rem;
    font-weight: 800;
  }
  .titlespan {
    margin-top: 1.375rem;
    color: #999;
  }
  .titlespan span {
    display: inline-block;
  }
  .titlespan img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
    vertical-align: bottom;
  }
  .titlespan2 {
    margin: 0 2.5rem;
  }
  .titlespan3 {
    font-size: 1rem;
  }
  .titlespan3 img {
    height: 2rem;
    width: 2rem;
    vertical-align: middle;
  }
  .content {
    margin: 2.5rem 0;
    color: #666666;
    text-align: left;
    line-height: 2rem;
  }
  .content div {
    margin-top: 0.625rem;
  }
  /* 内容 */
  .tent {
    margin-top: 4rem;
    font-size: 1rem !important;
    text-align: left;
    line-height: 1.8rem;
  }
  #lay_a {
    color: #308bec !important;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .zw{
    width: 80rem;
    height: 100rem;
    .box1{
      text-align: left;
      line-height: 1.8rem;
    }
    .box2{
      margin-top: 1rem;
      width: 60.5rem;
      height: 20rem;
      th{
        border: 1px solid black;
      width: 1.5em;
      height: 3.5em;
   
      text-align: center;
      vertical-align: middle;
      }
      table {
        width: 60.5rem;
      border-collapse: collapse;
      border-spacing: 1em 0.5em;
      padding: 0 2em 1em 0;
      border: 1px solid black;
   }
   td {
    border: 1px solid black;
      width: 3.5em;
      height: 2.5em;
   
      text-align: center;
      vertical-align: middle;
   }
    }
    .box3{
       margin-top: -9rem;
    }
    .box4{
       margin-top: 2rem;
    }
    .box5{
      margin-left: 70rem;
    }
    
  }
  .card_pop{
    
   
    color: #308bec;
    margin-top: 1.2rem;
    margin-right: 1rem;
  }
  .xzBtn{
    width:2.5rem;
   height: 1rem;
   border: 1px solid black;
 border-radius:5px ;
 padding-left: 0.5rem;
 font-size: 12px;
   margin-top: 1.4rem;
   margin-right: 3rem;
 
  }
  </style>